/**
 * Whether the signed-in user belongs to a new beta firm: one created through the
 * beta signup and onboarding path. The first-run moments (claim view tour,
 * first-claim panel) are for these users only, never for existing firms or
 * their staff, and never for superadmins.
 *
 * The signal is the firm's created_via_beta_signup flag (firmBilling on
 * /api/auth/user). Only POST /api/onboarding/firm sets it to true; every firm
 * that existed before beta signup has the column default (false), and it is
 * per firm, so it covers the firm's invited staff too. A created_at cutoff
 * would need a date to maintain and could catch a firm that was created by
 * other means after it.
 */
import { useAuth } from '@/hooks/use-auth';

export function useIsNewBetaFirmUser(): boolean {
  const { user } = useAuth();
  return user?.firmBilling?.createdViaBetaSignup === true && !user.isSuperAdmin;
}
